import { render, staticRenderFns } from "./adminProjects.vue?vue&type=template&id=db963eb0"
import script from "./adminProjects.vue?vue&type=script&lang=js"
export * from "./adminProjects.vue?vue&type=script&lang=js"
import style0 from "./adminProjects.vue?vue&type=style&index=0&id=db963eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports